import { s as serverErrors } from '../serverErrors-JVvpO9sB.js';
import logger from './logger.js';
import { logErrorToRelic } from './logToRelic.js';
import './logToSlack.js';

const extractErrorMessage = (err, defaultError) => {
    const message = err === null || err === void 0 ? void 0 : err.message;
    const formattedError = () => {
        logger(message, { type: 'error' });
        const errorObj = serverErrors.find(knownError => (knownError === null || knownError === void 0 ? void 0 : knownError.serverError) === message);
        if (errorObj && errorObj.userFriendlyError) {
            return errorObj.userFriendlyError;
        }
        return null;
    };
    if (message)
        return formattedError();
    return defaultError || null;
};
// Get user friendly error message
// TODO: Is this needed, or can we just use extractErrorMessage?
const processErrorMessage = (errorMessage, t) => {
    const errorObj = serverErrors.find(knownError => errorMessage.includes(knownError.serverError));
    if (errorObj) {
        logErrorToRelic(new Error(`${errorMessage} - ${errorObj.devMsg}`));
        return t(errorObj.userFriendlyError);
    }
    return errorMessage;
};

export { extractErrorMessage, processErrorMessage };
//# sourceMappingURL=error.js.map
